<template>
  <content-panel>
    <!--搜索-->
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" ref="searchForm">
          <div class="search-row">
            <el-form-item label="店铺">
              <el-select v-model="searchForm.storeCode" filterable placeholder="全部" @change="onSearchList">
                <!-- <el-option label="全平台" value="" /> -->
                <el-option v-for="item in useObjectList" :key="item.storeCode" :label="item.storeName" :value="item.storeCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="型号" prop="batchName">
              <el-input v-model.trim="searchForm.productType" placeholder="请输入型号" @keyup.enter.native="onSearchList"></el-input>
            </el-form-item>
            <el-form-item label="品类">
              <el-select v-model="searchForm.productCategory" filterable placeholder="全部" @change="onSearchList">
                <el-option label="全部" value="" />
                <el-option v-for="item in categorys" :label="item" :key="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.goodsNameList" @keyup.enter.native="onSearchList" />
            </el-form-item>
            <el-form-item label="商品编码">
              <el-input v-model="searchForm.goodsCodeList" @keyup.enter.native="onSearchList" />
            </el-form-item>
          </div>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearchList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>

    <!--列表-->
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button
          type="primary"
          size="mini"
          class="green-btn"
          v-permission="`ec-pc-new$pageMaterialManagement$shortVideoManagement$fullPlatformOverview $Logs`"
          @click="$router.push('/shortVideoFullLog')"
          >完整日志
        </el-button>
        <el-button
          type="primary"
          size="mini"
          class="green-btn"
          v-permission="`ec-pc-new$pageMaterialManagement$shortVideoManagement$fullPlatformOverview $BasicConfig`"
          @click="$router.push('/videoBasicConfiguration')"
          >基础配置
        </el-button>
        <el-button
          type="primary"
          size="mini"
          class="green-btn"
          v-permission="`ec-pc-new$pageMaterialManagement$shortVideoManagement$fullPlatformOverview $UploadVideo`"
          @click="$router.push('/shortVideoManagement')"
          >上传视频
        </el-button>
        <search-batch @seachFilter="seachFilter" :searchForm="searchForm" />
        <el-button type="primary" size="mini" class="green-btn" @click="exportExcel" style="margin-left: 10px">导出 </el-button>
      </template>
      <el-table
        ref="table"
        :height="maxTableHeight"
        border
        :data="tableData.records"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="goodsCode" label="商品编码" width="180">
          <template slot-scope="scope">
            <el-tooltip placement="right">
              <div slot="content" class="table-tip-box">
                {{ scope.row.goodsCode }}
              </div>
              <div class="table-ellipsis">{{ scope.row.goodsCode }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" width="200">
          <template slot-scope="scope">
            <el-tooltip placement="right">
              <div slot="content" class="table-tip-box">
                {{ scope.row.goodsName }}
              </div>
              <div class="table-ellipsis">{{ scope.row.goodsName }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productType" label="型号" align="center"> </el-table-column>
        <el-table-column prop="productCategory" label="品类"> </el-table-column>
        <el-table-column prop="mainPhotoCount" label="主图" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="videoShow(scope.row, 1)">{{ scope.row.mainPhotoCount }}</el-link>
            <div class="over-time-tag">
              <el-tag type="warning" size="mini" v-if="scope.row.newFlagMainPhoto == 'Y'">新</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mainPhotoLatestTime" label="主图拍摄时间" show-overflow-tooltip width="160"> </el-table-column>
        <el-table-column prop="microDetailCount" label="微详情" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="videoShow(scope.row, 2)">{{ scope.row.microDetailCount }}</el-link>
            <div class="over-time-tag">
              <el-tag type="warning" size="mini" v-if="scope.row.newFlagMicroDetail == 'Y'">新</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="microDetailLatestTime" label="微详情拍摄时间" show-overflow-tooltip width="160"> </el-table-column>
        <el-table-column prop="tikQuickCount" label="抖快" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="videoShow(scope.row, 3)">{{ scope.row.tikQuickCount }}</el-link>
            <div class="over-time-tag">
              <el-tag type="warning" size="mini" v-if="scope.row.newFlagTikQuick == 'Y'">新</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="tikQuickLatestTime" label="抖快拍摄时间" show-overflow-tooltip width="160"> </el-table-column>
        <el-table-column prop="surmiseFondCount" label="猜喜" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="videoShow(scope.row, 4)">{{ scope.row.surmiseFondCount }}</el-link>
            <div class="over-time-tag">
              <el-tag type="warning" size="mini" v-if="scope.row.newFlagSurmiseFond == 'Y'">新</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="surmiseFondLatestTime" label="猜喜拍摄时间" show-overflow-tooltip width="160"> </el-table-column>
        <el-table-column prop="otherCount" label="其他" width="100">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="videoShow(scope.row, 5)">{{ scope.row.otherCount }}</el-link>
            <div class="over-time-tag">
              <el-tag type="warning" size="mini" v-if="scope.row.newFlagOther == 'Y'">新</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="otherLatestTime" label="其他拍摄时间" show-overflow-tooltip width="160"> </el-table-column>
        <el-table-column prop="price" width="120px" align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="downloadDialog(scope.row)">查看下载日志</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <v-dialog v-model="dialogVisibleDownload" :config="{ showButton: false, width: '60%', title: '下载记录' }" @visibleUpdate="visibleUpdate">
      <div slot="content">
        <div style="padding-bottom: 10px">
          型号:<span class="downloadText">{{ dialogText[0] }}</span
          >品类:<span class="downloadText">{{ dialogText[1] }}</span>
        </div>
        <el-table border :data="dialogTableData.records" height="300px" v-loading="loading2">
          <el-table-column label="下载店铺" show-overflow-tooltip prop="storeName" align="center"></el-table-column>
          <el-table-column label="视频类型" show-overflow-tooltip prop="videoType" align="center"></el-table-column>
          <el-table-column label="文件名" show-overflow-tooltip prop="fileName" align="center"></el-table-column>
          <el-table-column label="下载人" show-overflow-tooltip prop="downloadUser" align="center"></el-table-column>
          <el-table-column label="下载时间" show-overflow-tooltip prop="downloadTime" align="center"></el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 15px">
          <el-pagination
            @size-change="operationSizeChange"
            @current-change="operationCurrentChange"
            :current-page="dialogTableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="dialogTableData.pageSize"
            :total="dialogTableData.total"
            background
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </div>
    </v-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="imgFormVisible" :close-on-click-modal="false" @cancel="updateVal" @close="updateVal" width="1150px">
      <imgShow
        :imgList="imgList"
        :imgForm="imgForm"
        :imgTitle="imgTitle"
        :storeCode="searchForm.storeCode"
        ref="imgShow"
        v-if="imgList.fileList && imgList.fileList.length && imgFormVisible"
      >
      </imgShow>
      <div class="no-data" style="text-align: center; color: #999999" v-else>暂无数据</div>
    </el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import imgShow from './common/imgShow.vue';
import searchBatch from './common/searchBatch.vue';
export default {
  name: 'videoFullPlatform',
  components: { imgShow, searchBatch },
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      // tableHeight: null,
      loading: false,
      loading2: false,
      searchForm: {
        productCategory: '',
        typeCategoryList: [],
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogTableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      rowData: {},
      searchFormData: {},
      dialogVisibleDownload: false,
      jurisdiction: false,
      useObjectList: [],
      downloadTextData: [],
      imgList: [],
      imgFormVisible: false,
      dialogTitle: '主图',
      dialogText: {},
      imgForm: {},
      imgTitleList: [],
      imgTitle: '',
      categorys: [],
    };
  },
  computed: {
    tableHeight() {
      let tableHeight = window.innerHeight - 221;
      return tableHeight;
    },
  },
  methods: {
    onSearch() {
      let { productType, productCategory, typeCategoryList, goodsCodeList, goodsNameList } = this.searchForm || {};
      let goodsCodeListType = goodsCodeList ? goodsCodeList.split(' ').length > 1000 : false;
      let goodsNameListType = goodsNameList ? goodsNameList.split(' ').length > 1000 : false;
      if (goodsCodeListType || goodsNameListType) {
        this.$message.error('已超过1000条，请核对！');
        return;
      }
      this.loading = true;
      let param = {
        filterData: {
          pageNum: this.tableData.pageNum,
          pageSize: this.tableData.pageSize,
          //...this.searchForm, 后端要求暂时不传店铺
          // storeCode: this.searchForm.storeCode,
          productType: productType,
          productCategory: productCategory,
          typeCategoryList: typeCategoryList,
          goodsCodeList: goodsCodeList ? goodsCodeList.split(' ') : [],
          goodsNameList: goodsNameList ? goodsNameList.split(' ') : [],
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.searchFormData = param;
      this.$q.shortVideoOverview
        .videoOverviews({ data: JSON.stringify(param) })
        .then((res) => {
          this.tableData = res.data;
          if (res.code == 200) {
          }
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    // 确认批量搜索
    seachFilter(data) {
      this.$set(this.searchForm, 'typeCategoryList', data);
      this.onSearchList();
    },
    downloadDialog(row) {
      this.dialogText = [row.productType, row.productCategory];
      this.dialogVisibleDownload = true;
      this.downloadLogs(row);
    },
    visibleUpdate() {
      this.dialogTableData.pageNum = 1;
      this.dialogTableData.pageSize = 30;
    },
    updateVal() {
      this.$refs.imgShow.checkedCities = [];
    },
    downloadLogs(row) {
      this.rowData = row || this.rowData;
      this.loading2 = true;
      let param = {
        pageNum: this.dialogTableData.pageNum,
        pageSize: this.dialogTableData.pageSize,
        storeCode: this.searchForm.storeCode,
        productType: this.rowData.productType,
        productCategory: this.rowData.productCategory,
      };
      this.$q.shortVideoOverview.downloadLogs({ data: JSON.stringify(param) }).then((res) => {
        this.dialogTableData = res.data;
        if (res.code == 200) {
          this.loading2 = false;
        }
      });
    },
    videoShow(row, index) {
      this.dialogTitle = index == 1 ? '主图' : index == 2 ? '微详情' : index == 3 ? '抖快' : index == 4 ? '猜喜' : '其他';
      this.imgTitle =
        index == 1
          ? this.imgTitleList.mainPhoto
          : index == 2
          ? this.imgTitleList.microDetail
          : index == 3
          ? this.imgTitleList.tikQuick
          : index == 4
          ? this.imgTitleList.surmiseFond
          : this.imgTitleList.other;
      let data = {
        productCategory: row.productCategory,
        productType: row.productType,
        videoType: index,
      };
      this.imgForm = data;
      console.log(data);
      this.$q.shortVideoOverview.videoTypeFiles({ fragment: [data.productType, data.productCategory, data.videoType] }).then((res) => {
        this.imgList = res.data;
        if (res.code == 200) {
          this.imgFormVisible = true;
          this.onSearch(); //需重新调用让点击的新消失
        }
      });
      // this.imgList = [
      //   {label:'106302-1高箱床',video: "https://s27.aconvert.com/convert/p3r68-cdx67/8nk56-byvcs.mp4"},
      //   {label:'106302-2高箱床',video: "https://s27.aconvert.com/convert/p3r68-cdx67/8nk56-byvcs.mp4"},
      //   {label:'106302-3高箱床',video: "https://s27.aconvert.com/convert/p3r68-cdx67/8nk56-byvcs.mp4"},
      //   {label:'106302-4高箱床',video: "https://s27.aconvert.com/convert/p3r68-cdx67/8nk56-byvcs.mp4"},
      //   {label:'106302-5高箱床',video: "https://s27.aconvert.com/convert/p3r68-cdx67/8nk56-byvcs.mp4"},
      //   {label:'106302-6高箱床',video: "https://s27.aconvert.com/convert/p3r68-cdx67/8nk56-byvcs.mp4"},
      // ];
    },
    async titleInit() {
      let res = await this.$q.shortVideoOverview.BulletinSeach();
      if (res.success && res.data) {
        this.imgTitleList = res.data;
      }
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    resetForm() {
      this.initSearchForm();
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    initSearchForm() {
      this.searchForm = {
        storeCode: this.useObjectList.length ? this.useObjectList[0].storeCode : '',
        productCategory: '',
        typeCategoryList: [],
      };
    },
    onSizeChange(pageSize) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = pageSize;
      this.loading = true;
      this.onSearch();
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.loading = true;
      this.onSearch();
    },
    operationSizeChange(pageSize) {
      this.dialogTableData.pageNum = 1;
      this.dialogTableData.pageSize = pageSize;
      this.downloadLogs();
    },
    operationCurrentChange(pageNum) {
      this.dialogTableData.pageNum = pageNum;
      this.downloadLogs();
    },
    storeSelect() {
      this.loading = true;
      this.$q.shortVideoOverview.videoUserStores({}).then((res) => {
        this.useObjectList = res.data;
        if (res.data.length) {
          this.$set(this.searchForm, 'storeCode', res.data[0].storeCode);
        }
        this.onSearch();
      });
    },
    videoCriterias() {
      this.$q.shortVideoOverview.videoCriterias({}).then((res) => {
        this.categorys = res.data.categorys;
      });
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData.filterData,
          exportTag: true,
        },
        reportName: 'shortVideoOverviewExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },

  mounted() {
    this.storeSelect();
    this.titleInit();
    this.videoCriterias();
  },
};
</script>

<style lang="stylus" scoped>

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

>>> .el-input--small .el-input__inner {
  height: 28px;
  line-height: 28px;
}

.downloadText {
  &::before {
    content: '';
    margin-left: 5px;
  }

  &::after {
    content: '';
    margin-right: 30px;
  }
}

>>> .el-dialog {
  margin: 50px auto !important
}

.no-data
  height calc(100vh - 300px)
  line-height calc(100vh - 300px)

.over-time-tag {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translate(0, -50%);
}
.table-ellipsis {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
}
// 提示框的最大宽度
.table-tip-box {
  max-width: 500px;
}
</style>
